export default function (maybeFunc) {
    return typeof maybeFunc === 'function';
}